var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx:trending-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9168 13.4511L18.0835 18.6178L25.455 11.2462L28.4168 14.208V6.45801H20.6668L23.6286 9.4198L18.0835 14.9649L12.9168 9.79826L2.96191 19.7531L4.78833 21.5796L12.9168 13.4511Z",
    fill: "#0BCB7A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp);
export default __webpack_public_path__ + "static/media/trending-up.e96c8ffd417e39720872d7a9dec5e4d9.svg";
export { ForwardRef as ReactComponent };